module.exports = __webpack_public_path__ + "static/media/NFL.2e832040.svg";